module.exports = __webpack_public_path__ + "static/media/dice-six.29ea21d5.svg";